import {
  SET_DESTRUCTIVE_ACTION_PENDING,
  SET_PENDING_DESTRUCTIVE_NAVIGATION,
} from '../actions/destructiveModal';

const initialState = {
  isDestructiveActionPending: false,
  pendingNavigation: null,
  pendingNavigationTriggerOrigin: null,
};

const destructiveModal = (state = initialState, action) => {
  switch (action.type) {
    case SET_DESTRUCTIVE_ACTION_PENDING:
      return {
        ...state,
        isDestructiveActionPending: action.pending,
      };
    case SET_PENDING_DESTRUCTIVE_NAVIGATION:
      return {
        ...state,
        pendingNavigation: action.url,
        pendingNavigationTriggerOrigin: action.origin ?? null,
      };
    default:
      return state;
  }
};

export default destructiveModal;
